import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-retired',
  templateUrl: './retired.component.html',
  styleUrls: ['./retired.component.scss']
})
export class RetiredComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}